import { render } from "./UniformFileUpload.vue?vue&type=template&id=352c6ae1&scoped=true"
import script from "./UniformFileUpload.vue?vue&type=script&lang=js"
export * from "./UniformFileUpload.vue?vue&type=script&lang=js"

import "./UniformFileUpload.vue?vue&type=style&index=0&id=352c6ae1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352c6ae1"]])

export default __exports__